export class SimpleStore {
	constructor() {
		this.debug = false;
		this.state = {
			screen: "external", // external, lobby, stairwell
			lastUpdate: "Never",
			lastDataUpdate: "Never",
			directoryData: [],
			locationData: [],
			labelData: [],
			activeImageFetchRequests: [],
      popupData: {},
			todaysEventsData: {},
			currentMap: "gardens",
			directoryOpen: false,
			directoryMap: "main",
			directorySelection: "",
			subcategorySelection: "",
			currentLocation: "",
			currentData: {},
			backButtonTarget: "", // directory, map
			showOutdoorPath: false, // whether to display preferred garden route path
			mapZoomDelta: 0,
			lastZoomUpdate: 0,
			languageCode: "en",
			languageString: "",
			emergencyExitsVisible: false,
		};
	}

	setScreenLocation(loc) {
		if (this.debug) {
			console.log("Updating screen location - ", loc);
		}

		this.state.screen = loc;
		this.state.lastUpdate = Date.now();
	}

	setDirectoryData(data) {
		if (this.debug) {
			console.log("Updating directory data - ", data);
		}

		this.state.directoryData = data;
		this.state.lastUpdate = Date.now();
		this.state.lastDataUpdate = Date.now();
	}

	setLocationData(data) {
		if (this.debug) {
			console.log("Updating location data - ", data);
		}

		this.state.locationData = data;
		this.state.lastUpdate = Date.now();
		this.state.lastDataUpdate = Date.now();
	}

	updateLocationData(index, data) {
		// used to update a specific location when new data is recieved
		if (this.debug) {
			console.log("Adding ", data ," to index ", index);
		}

		// update location data array
		this.state.locationData[index] = data;

		// update directory data object
		this.state.directoryData.forEach((tab) => {
			tab.categories.forEach((category) => {
				category.locations.forEach((location) => {
					if (location.id === data.id) {
						Object.keys(data).forEach((key) => {
							location[key] = data[key];
						});
					}

					// check subcategories as well
					location.subcategories.forEach((sub) => {
						if (sub.id === data.id) {
							Object.keys(data).forEach((key) => {
								sub[key] = data[key];
							});
						}
					});
				});
			});
		});

		this.state.lastUpdate = Date.now();
		this.state.lastDataUpdate = Date.now();
	}

	addImageFetchFlag(index) {
		if (this.state.activeImageFetchRequests.indexOf(index) <= -1) {
			this.state.activeImageFetchRequests.push(index);
		}
	}

	addImageForLocation(index, data) {
		if (this.debug) {
			console.log("Adding ", data ," to index ", index);
		}

		let location = this.state.locationData[index];
		location.images.push(data);

		// check to see if all images have been fetched
		if (location.images.length === location.imagesRaw.length) {
			// fetching complete
			let flagIndex = this.state.activeImageFetchRequests.indexOf(index);
			if (flagIndex > -1) {
				this.state.activeImageFetchRequests.splice(flagIndex, 1);
			}
		} else if (location.images.length > location.imagesRaw.length) {
			console.error("Pushed too many images to ", location.name);
		}

		this.state.lastDataUpdate = Date.now();
	}

	getLocationIndexByCode(code) {
		let locationIndex = -1;
		for (let i = 0; i < this.state.locationData.length; i++) {
			if (this.state.locationData[i].code === code) {
				locationIndex = i;
				break;
			}
		}

		return locationIndex;
	}

	getLocationIndexById(id) {
		let locationIndex = -1;
		for (let i = 0; i < this.state.locationData.length; i++) {
			if (this.state.locationData[i].id === id) {
				locationIndex = i;
				break;
			}
		}

		return locationIndex;
	}

  setPopupData(data) {
    if (this.debug) {
			console.log("Updating popup data - ", data);
    }

    this.state.popupData = data;
    this.state.lastUpdate = Date.now();
    this.state.lastDataUpdate = Date.now();
      
  }

	setTodaysEvents(data) {
		if (this.debug) {
			console.log("Updating today's events data - ", data);
		}

		this.state.todaysEventsData = data;
		this.state.lastUpdate = Date.now();
		this.state.lastDataUpdate = Date.now();
	}

	setMapLabelData(data) {
		if (this.debug) {
			console.log("Updating location data - ", data);
		}

		this.state.labelData = data;
		this.state.lastUpdate = Date.now();
		this.state.lastDataUpdate = Date.now();
	}

	updateMapLabelData(data) {
		// used to update a specific location when new data is recieved
		if (this.debug) {
			console.log("Adding ", data);
		}

		// update entries in label array
		data.forEach((label) => {
			let labelIndex = this.getLabelById(label.id);
			if (labelIndex > -1) {
				this.state.labelData[labelIndex] = label;
			} else {
				this.state.labelData.push(label);
			}
		});

		console.log(this.state.labelData);

		this.state.lastUpdate = Date.now();
		this.state.lastDataUpdate = Date.now();
	}

	getLabelById(id) {
		let labelIndex = -1;
		for (let i = 0; i < this.state.labelData.length; i++) {
			if (this.state.labelData[i].id === id) {
				labelIndex = i;
				break;
			}
		}

		return labelIndex;
	}

	setCurrentMap(map) {
		if (this.debug) {
			console.log("Setting current map - ", map);
		}

		this.state.currentMap = map;
		// reset location when switching maps
		this.state.currentLocation = "";
		this.state.currentData = {};
	}

	setCurrentLocation(locationCode) {
		if (this.debug) {
			console.log("Setting new location - ", locationCode);
		}
		this.state.currentLocation = locationCode;
	}

	setDirectoryOpen(data) {
		if (this.debug) {
			console.log("Updating directory open state - ", data);
		}

		this.state.directoryOpen = data;
		this.state.lastUpdate = Date.now();
	}

	setDirectoryMap(map) {
		if (this.debug) {
			console.log("Setting directory map - ", map);
		}

		this.state.directoryMap = map;
	}

	setDirectorySelection(data) {
		if (this.debug) {
			console.log("Updating directory selection - ", data);
		}

		this.state.directorySelection = data;
		this.state.lastUpdate = Date.now();
	}

	setSubcategorySelection(data) {
		if (this.debug) {
			console.log("Updating subcategory selection - ", data);
		}

		this.state.subcategorySelection = data;
		this.state.lastUpdate = Date.now();
	}

	setBackTarget(data) {
		if (this.debug) {
			console.log("Updating back button target - ", data);
		}

		this.state.backButtonTarget = data;
		this.state.lastUpdate = Date.now();
	}

	setOutdoorPathState(data) {
		if (this.debug) {
			console.log("Updating outdoor path display - ", data);
		}

		this.state.showOutdoorPath = data;
		this.state.lastUpdate = Date.now();
	}

	increaseMapZoom() {
		if (this.debug) {
			console.log("increasing map zoom");
		}

		this.state.mapZoomDelta = 1;
		this.state.lastZoomUpdate = Date.now();
	}

	decreaseMapZoom() {
		if (this.debug) {
			console.log("decreasing map zoom");
		}

		this.state.mapZoomDelta = -1;
		this.state.lastZoomUpdate = Date.now();
	}

	setLanguage(code, fullName) {
		if (this.debug) {
			console.log("Setting language - ", code, fullName);
		}

		this.state.languageCode = code;
		this.state.languageString = fullName;
	}

	setEmergencyExitsVisible(visible) {
		if (this.debug) {
			console.log("Setting emergency exit visibility - ", visible);
		}

		this.state.emergencyExitsVisible = visible;
		this.state.lastUpdate = Date.now();
	}
}